(function ($) {
  var $window = $(window);
	var $document = $(document);

  $(function () {
    var page = 1;
    var limit = 20;
    var $membersDir = $('#members-dir-list');
    var $memberList = null;
    var $pageCount = null;
    var $selected = null;
    var startsWith = "";
    var isDisabled = false;

    function AjaxErr(err) {
      console.log(err);
      alert("Sorry, there was an error. Please refresh the page and try again.");
    }

    function GetMemeberCountString(membersCount, total) {
      var count = 0;
      if (membersCount === limit) {
        count = (limit * page);
      } else {
        count = ((limit * (page - 1)) + membersCount);
      }
      return 'Viewing 1 - ' + count + ' of ' + total + ' members';
    }

    // Filter items by char
		$document.on('click', '.ld-alphabetical-pagination a', function(e) {
			e.preventDefault();
      
      var char = $(this).attr('data-char');
			$document.trigger('ld-alphabetical-pagination', [char]);
		});
		
		$document.on('ld-alphabetical-pagination', function(e, char) {
			if($membersDir.hasClass('loading')) {
				return;
      }

      //Reset page count as we're doing a new filter
      page = 1;
      isDisabled = false;
      startsWith = char ? char : "";

      $membersDir.addClass('loading');

      //Deselected previous filter
      if (!$selected) {
        $selected = $('.ld-alphabetical-pagination a.selected');
      }
      $selected.removeClass('selected');
      // Reset scroll message for new filter
      $membersDir.find('.load-more h4').text("Scroll To Load More");

			$.ajax({
				url: window.ld.homeUrl + '/wp-admin/admin-ajax.php?action=MembersLoop_MembersList',
				method: 'POST',
				data: {
          'page': page,
          'count': limit,
					'startsWith': startsWith
				}
			}).then(function (res) {
				if (!res.success) {
          return AjaxErr(res);
        }

        if (res.result.html) {
          if (!$memberList) {
            $memberList = $('#members-list');
          }

          if (!$pageCount) {
            $pageCount = $('.bp-pagination .pag-count .pag-data');
          }

          //Set new 'selected' char
          $selected = $('.ld-alphabetical-pagination a[data-char="' + startsWith + '"]');
          $selected.addClass('selected');

          var members = res.result.html;
          var membersCount = $(members).filter("li").length;

          if (membersCount <= 0 && page === 1) {
            isDisabled = true;
            $pageCount.each(function () {
              $(this).html('Viewing 0 - 0 of 0 members');
            });
            $membersDir.find('.load-more h4').text("");
            $memberList.html(members);
            return;
          }

          var memberCountString = GetMemeberCountString(membersCount, res.result.totalMembers);
          $pageCount.each(function () {
            $(this).html(memberCountString);
          });

          //Overwrite member list as we're doing a new filter
          $memberList.html(members);
        }
			}, AjaxErr).always(function() {
				$membersDir.removeClass('loading');
			});
		});

    $window.on('scroll', function (ev) {
      if ((window.innerHeight + window.pageYOffset) >= (document.body.offsetHeight - 100)) {
        if ($membersDir.length <= 0 || $membersDir.hasClass('loading')) {
          return;
        }
        page++;
        $membersDir.trigger('ld.memberScrollLoad');
      }
    });

    $membersDir.on('ld.memberScrollLoad', function (e) {

      if(isDisabled) {
        return;
      }

      if ($membersDir.hasClass('loading')) {
        return;
      }

      $membersDir.addClass('loading');
      $.ajax({
				url: window.ld.homeUrl + '/wp-admin/admin-ajax.php?action=MembersLoop_MembersList',
        method: 'POST',
        data: {
          'page': page,
          'count': limit,
					'startsWith': startsWith
				}
      }).then(function (res) {
        if (!res.success) {
          return AjaxErr(res);
        }

        if (res.result.html) {
          if (!$memberList) {
            $memberList = $('#members-list');
          }

          if (!$pageCount) {
            $pageCount = $('.bp-pagination .pag-count .pag-data');
          }

          var members = res.result.html;
          var membersCount = $(members).filter("li").length;

          if (membersCount <= 0) {
            isDisabled = true;
            $membersDir.find('.load-more h4').text("No more members");
            return;
          }

          var memberCountString = GetMemeberCountString(membersCount, res.result.totalMembers);
          $pageCount.each(function () {
            $(this).html(memberCountString);
          });

          $memberList.append(members);
        }
      }, AjaxErr).always(function () {
        $membersDir.removeClass('loading');
      });
    });

  });
})(jQuery);
